import { useQuery } from '@tanstack/react-query';

import { AWS_CONFIG } from '../config/aws';
import { ME_QUERY } from '../graphql/queries';
import { gql } from '../lib/api';

interface CurrentUser {
  email: string;
  role: 'viewer' | 'admin';
}

export const AccountPage = () => {
  const { data, isPending, error } = useQuery({
    queryKey: ['current-user'],
    queryFn: () => gql<{ me: CurrentUser }>(ME_QUERY),
  });

  return (
    <div>
      <h1 style={styles.title}>アカウント</h1>
      <section style={styles.section}>
        <h2 style={styles.heading}>ログイン情報</h2>
        {isPending ? (
          <p style={styles.note}>読み込み中...</p>
        ) : error ? (
          <div style={styles.error}>{error.message}</div>
        ) : (
          <dl style={styles.detailList}>
            <dt style={styles.term}>メールアドレス</dt>
            <dd style={styles.description}>{data?.me.email ?? '-'}</dd>
            <dt style={styles.term}>権限</dt>
            <dd style={styles.description}>{data?.me.role === 'admin' ? '管理者' : '閲覧者'}</dd>
          </dl>
        )}
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>共通アカウント設定</h2>
        <p style={styles.note}>パスキーやプロフィールは共通アカウントセンターで管理します。</p>
        <a href={AWS_CONFIG.cognito.accountCenterUrl} style={styles.primaryLink}>
          アカウントセンターを開く
        </a>
      </section>
    </div>
  );
};

const styles = {
  title: { margin: '0 0 1rem', fontSize: '1.5rem' },
  section: {
    marginBottom: '1rem',
    padding: '1.25rem',
    background: '#fff',
    border: '1px solid #d4d1cf',
    borderRadius: 8,
  },
  heading: { margin: 0, fontSize: '1.05rem' },
  note: { margin: '0.75rem 0', color: '#6c757d', fontSize: '0.9rem' },
  detailList: {
    display: 'grid',
    gridTemplateColumns: '9rem 1fr',
    gap: '0.5rem 1rem',
    margin: '1rem 0 0',
  },
  term: { color: '#6c757d', fontSize: '0.88rem' },
  description: { margin: 0, fontSize: '0.95rem' },
  primaryLink: {
    display: 'inline-block',
    marginTop: '0.25rem',
    padding: '0.65rem 0.9rem',
    borderRadius: 6,
    background: '#aa0b56',
    color: '#fff',
    fontWeight: 700,
    textDecoration: 'none',
  },
  error: {
    marginTop: '1rem',
    padding: '0.75rem',
    borderRadius: 6,
    border: '1px solid #ffc9c9',
    background: '#fff5f5',
    color: '#aa0b56',
    fontSize: '0.88rem',
  },
} as const satisfies Record<string, React.CSSProperties>;
